import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise } from 'axios';

const ROOT_PATH = 'bopArchives';
class BopArchiveService {
    // public getTableUrl(lang:string): string {
    //     return `${apiProvider.getUrl()}${rootPath}${toUrl({lang: lang})}`;
    // }

     public getBopArchive(bopId: string): AxiosPromise<any> {
        return apiClient.get(`${ROOT_PATH}/byBop${buildQuery({bopId})}`);
     }
 
}

export default new BopArchiveService();